import { render } from "./ApportionOrder.vue?vue&type=template&id=ef02f5a6&scoped=true"
import script from "./ApportionOrder.vue?vue&type=script&lang=js"
export * from "./ApportionOrder.vue?vue&type=script&lang=js"

import "./ApportionOrder.vue?vue&type=style&index=0&id=ef02f5a6&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef02f5a6"]])

export default __exports__